<ng-container
  *ngComponentOutlet="
    components()[variant].component;
    inputs: components()[variant].inputs
  "
/>
